import { createSlice } from '@reduxjs/toolkit';


const loadState = (): boolean => {
    const savedState = localStorage.getItem('themeState');
    return savedState === 'true';
};

const initialState: boolean = loadState();

const themeSlice = createSlice({
    name: 'themeState',
    initialState,
    reducers: {
        toggleTheme: (state) => {
            const newState = !state;
            localStorage.setItem('themeState', newState.toString());
            return newState;
        },
    },
});

export const { toggleTheme } = themeSlice.actions;

export default themeSlice.reducer;